import React from 'react'
import { Box, TextBody } from '@ally/metronome-ui'
import { WidgetKey } from '../../types'
import { useCustomizeDashboard } from '../../CustomizeDashboardContext/CustomizeDashboardContext'

const WidgetTypeItem: React.FC<{ name: WidgetKey }> = ({ name }) => {
  const [{ eligibleWidgets }] = useCustomizeDashboard()
  const { displayName, description } = eligibleWidgets[name]?.copy ?? {}
  return (
    <Box display="flex" alignItems="center">
      <TextBody tag="span" size="sm">
        <TextBody tag="span" size="sm" weight="bold">
          {displayName}:
        </TextBody>{' '}
        {description}
      </TextBody>
    </Box>
  )
}

export default WidgetTypeItem
